export enum DecoratorType {
    ADD = "add",
    SEARCH = "search",
    UPDATE = "update",
    ADVANCED = "advanced",
    REPORT = "report",
    TASK = "task"
}
